<instrumentsearch
    *ngIf="parameters.step === 'instrument-search'"
    [allowRecommendations]="false"
    [selectNewInstrumentPatch]="parameters.replacePatch.bind(this)"
    [selectedTrackBus]="parameters.trackBus"
    [layer]="parameters.layer"
    (close)="close.emit()"></instrumentsearch>
